import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ResizableColumnsService {
  private progressSubject = new BehaviorSubject<{ total: number; completed: number }>({ total: 0, completed: 0 });
  private completeSubject = new Subject<void>();
  private isComplete = false;

  progress$ = this.progressSubject.asObservable(); // Observable per monitorare il progresso
  complete$ = this.completeSubject.asObservable(); // Observable per notificare il completamento

  initialize(totalColumns: number) {
    this.progressSubject.next({ total: totalColumns, completed: 0 });
  }

  reset(){
    this.isComplete = false;
    const progress = this.progressSubject.getValue();
    this.progressSubject.next({ total: progress.total, completed: 0 });
  }

  columnResized() {
    const progress = this.progressSubject.getValue();
    const updatedProgress = { total: progress.total, completed: progress.completed + 1 };

    this.progressSubject.next(updatedProgress);

    // Emitto l'evento di completamento quando tutte le colonne sono ricalcolate
    if (updatedProgress.completed >= updatedProgress.total && !this.isComplete) {
      this.isComplete = true;
      this.completeSubject.next(); // Notifica che il ricalcolo è completo
      this.reset();
    }
  }
}
